import React from 'react';
import { Link } from 'react-router';
import { Image } from 'App';

require('./stylesheets/PortfolioList.scss');

const PortfolioList = (props) => {
  const projects = props.data.map(item => {
    let image;

    if (item.featured_image) {
      image = <Link to={ `portfolio/${item.slug}` }><Image featured_image={ item.featured_image } alt_text={ item.alt_text } /></Link>
    }

    return (
      <div key={ item.id } className={ (props.rows === true) ? 'row' : '' } >
        <div className="project">
          <h3><Link to={ `portfolio/${item.slug}` }>{ item.title }</Link></h3>
          { image }
          <p>{ item.excerpt }</p>
        </div>
      </div>
    );
  });

  return (
    <div>
      { projects }
    </div>
  );
};

export default PortfolioList;




// WEBPACK FOOTER //
// ./app/src/Portfolio/components/PortfolioList.js